import { render, staticRenderFns } from "./RecordSheet.vue?vue&type=template&id=37f7446a"
import script from "./RecordSheet.vue?vue&type=script&lang=js"
export * from "./RecordSheet.vue?vue&type=script&lang=js"
import style0 from "./RecordSheet.vue?vue&type=style&index=0&id=37f7446a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../pws_portal/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports